import system from "system-components";

export const ModalFooter = system(
  {
    width: 1,
    bg: "nav.95"
  },
  "space",
  "display",
  "position"
).extend`
  justify-content: ${({ justifyContent }) => justifyContent};
  flex-direction: ${({ flexDirection }) => flexDirection};
`;
